import { throttle } from '../helpers';
import './../../styles/templates/blog.scss';

(function($) {
  const dynamicScrollbars = document.querySelectorAll('[data-scrollbar-dynamic-sides]');

  const updateDynamicScrollbar = function(dynamicScrollbarWrapper, scrollbar) {
    const direction = scrollbar.getAttribute('data-scrollbar-dynamic-sides-direction');

    if(direction && direction.toLowerCase() === 'x') {
      if(!scrollbar.scrollLeft) {
        dynamicScrollbarWrapper.classList.add('dynamic-scrollbar--touching-left');
      } else {
        dynamicScrollbarWrapper.classList.remove('dynamic-scrollbar--touching-left');
      };

      if(scrollbar.clientWidth + scrollbar.scrollLeft == scrollbar.scrollWidth) {
        dynamicScrollbarWrapper.classList.add('dynamic-scrollbar--touching-right');
      } else {
        dynamicScrollbarWrapper.classList.remove('dynamic-scrollbar--touching-right');
      }
    }

    // To Do: make it work with vertical scrollbars too
    if(!dynamicScrollbarWrapper.classList.contains('dynamic-scrollbar--ready')) dynamicScrollbarWrapper.classList.add('dynamic-scrollbar--ready');
  };

  if(dynamicScrollbars.length) {
    Array.from(dynamicScrollbars).map(dynamicScrollbarWrapper => {
      let scrollbar = dynamicScrollbarWrapper;
      const dynamicScrollableElement = dynamicScrollbarWrapper.querySelector('[data-scrollbar-dynamic-sides-scroll-element]');
      if(dynamicScrollableElement) scrollbar = dynamicScrollableElement;

      scrollbar.addEventListener('scroll', throttle(() => updateDynamicScrollbar(dynamicScrollbarWrapper, scrollbar), 100));
      window.addEventListener('resize', throttle(() =>  updateDynamicScrollbar(dynamicScrollbarWrapper, scrollbar), 300));
      updateDynamicScrollbar(dynamicScrollbarWrapper, scrollbar);
    });
  }
})(jQuery);
